<template>
    <span>
        {{ $t('cart.limitations.noDeliveryOnPostCode') }}
        <template v-if="postCodeSwitchModal">
            {{ $t('cart.limitations.pleaseChooseAnother') }}
            <button type="button" @click="openModal">
                <span class="underline">{{ $t('cart.limitations.postalCode').toLowerCase() }}</span>
            </button>.
            <template v-if="webshopSettings().pickupIsEnabled">
                {{ ' ' }}{{ $t('cart.limitations.noDeliveryChangePickupBeforeLink') }}
                <DispatchTypeLink :dispatch-type="DispatchTypeOrderBuddy.PICK_UP" class="underline">
                    {{ $t('cart.limitations.noDeliveryChangePickupLink') }}
                </DispatchTypeLink>
            </template>
        </template>
        <DispatchTypeLink v-else-if="webshopSettings().pickupIsEnabled" :dispatch-type="DispatchTypeOrderBuddy.PICK_UP" class="underline">
            {{ capitalize($t('cart.limitations.noDeliveryChangePickupLink')) }}
        </DispatchTypeLink>
    </span>
</template>

<script lang="ts" setup>
    import capitalize from 'lodash.capitalize'
    import { useModalSlot } from 'vue-final-modal'
    import DispatchTypeLink from '~/components/DispatchTypeLink.vue'
    import ModalContentModifyPostalCode from '~/components/Modal/Content/ModalContentModifyPostalCode.vue'
    import { messagesModal } from '~/composables/messagesModal'
    import { webshopSettings } from '~/store/webshopSettings'
    import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    defineProps({
        postCodeSwitchModal: {
            type: Boolean,
            default: true
        }
    })
    async function openModal () {
        const modalInstance = await messagesModal({
            default: useModalSlot({
                component: ModalContentModifyPostalCode,
                attrs: {
                    closeModal: () => {
                        modalInstance.close()
                    }
                }
            })
        })
    }
</script>
